<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Status </label>
          <div class="p-col">
            <v-select
              :disabled="obj_data.rental_order.booking_status === 'Reject' || obj_data.rental_order.booking_status === 'Complete'"
              :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
              placeholder="Choose" v-model="obj_data.rental_order.booking_status" :options="listStatus"
              :reduce="item => item.id" label="name" @input="handleStatusChange">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="status">
          </div>
        </div>
        <div v-if="obj_data.rental_order.booking_status === 'Reject'" class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right">Note </label>
            <div class="p-col">
              <Textarea :disabled="true" id="model" v-model="obj_data.reject_reason" placeholder="Input"  class="reason-style"/>
            </div>
          </div>
        </div>
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Drop-off showroom </label>
          <div class="p-col">
            <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
              placeholder="Choose" v-model="obj_data.showroom.id" :options="listShowRoom" :reduce="item => item.id"
              label="name">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="sell_showroom_id">
          </div>
        </div>
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Appoinment </label>
          <div class="p-col">
            <Calendar :showOnFocus="false" dateFormat="dd/mm/yy" :showIcon="true" appendTo="self" :showClear="true" :minDate="new Date()" 
              :manualInput="false" v-model="obj_data.sell_drop_off_date" placeholder="YYYY" />
            <input class="input_tmp_validator" id="sell_drop_off_date" />
          </div>
        </div>


        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right ">CAR INFOMATION</label>
          <div class="p-col">
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Plate number </label>
            <div class="p-col">
              <InputText id="sell_plate_number" v-model="obj_data.sell_plate_number" placeholder="Input" />
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Rego validation </label>
            <div class="p-col">
                <Calendar1 style="width: 100%" v-model="obj_data.sell_rego_validation" view="month" dateFormat="mm/yy"
                appendTo="self" :showIcon="true" placeholder="MM/YYYY" />
              <input class="input_tmp_validator" id="sell_rego_validation" />
            </div>
          </div>

        </div>
        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required ">Odometer </label>
            <div class="p-inputgroup custom-input-value">
              <InputNumber v-model="obj_data.odometer" :min="0" id="odometer" :minFractionDigits="0" :maxFractionDigits="0"
               placeholder="0" />
              <span class="p-inputgroup-addon custom-input-value-a">km</span>
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required ">Price </label>
            <div class="p-inputgroup custom-input-value">
              <InputNumber v-model="obj_data.price" :min="0" id="price" :minFractionDigits="2" :maxFractionDigits="2"
               placeholder="0" />
              <span class="p-inputgroup-addon custom-input-value-a">$</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Car image </label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFile" multiple /><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right ">CONTACT INFOMATION</label>
          <div class="p-col">
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right">User </label>
            <div class="p-col">
              <InputText id="user" v-model="obj_data.rental_order.user.fullname" placeholder="Input" :disabled="true" />
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Full name </label>
            <div class="p-col">
              <InputText id="fullname" v-model="obj_data.fullname" placeholder="Input" />
            </div>
          </div>
        </div>

        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Phone number </label>
            <div class="p-col">
              <InputText id="phone" type="number" v-model="obj_data.phone" placeholder="Input" @input="formatPhoneNumber"
               />
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right txt-required">Email </label>
            <div class="p-col">
              <InputText id="email" v-model="obj_data.email" placeholder="Input" />
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log ">
            <label class="chu-in-dam-purchase p-col-fixed txt-right">Note </label>
            <div class="p-col">
              <Textarea id="model" v-model="obj_data.rental_order.note" placeholder="Input" />
            </div>
          </div>
        </div>

      </div>


      <div class="col-6" v-if="obj_data.rental_order.booking_status === 'Complete'">
        <div class="p-card-field">
          <label class="chu-in-dam-purchase p-col-fixed txt-right ">ORDER INFOMATION</label>
          <div class="p-col">
          </div>
        </div>
        <div class="p-card-field ">
          <div style="flex: 1;">
            <div class="p-col" style="display: flex; gap: 10px;">
              <div style="flex: 1;">
                <label class="chu-in-dam-purchase p-col-fixed txt-right margin-info-order">Order amount </label>
                <div class="p-inputgroup">
                  <InputText id="BUY_A_CAR_CUMULATIVE_SPENDING" v-model="formattedPriceSale" placeholder="0"
                    :disabled="true" />
                  <span class="p-inputgroup-addon">$</span>
                </div>
              </div>
              <div style="flex: 1;">
                <label class="chu-in-dam-purchase p-col-fixed txt-right margin-info-order">Points reward </label>
                <div class="p-inputgroup">
                  <InputText id="POINTS_REWARD_BUY" v-model="formattedPointWallet" placeholder="0" :disabled="true" />
                  <span class="p-inputgroup-addon">point</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>




      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
      <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
        Are you sure you want to delete?
        <template #footer>
          <Button label="Delete" @click="deleteData()" icon="pi pi-check"
            class="p-button-danger  btn-confirm-delete-dialog" />
          <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        </template>
      </Dialog>



      <Dialog :header="dialogHeader" :visible.sync="showDeleteDialogComplete" :contentStyle="{ overflow: 'visible' }"
        :modal="true">
        <p>This car has been purchased by Hera. Are you sure you want to continue?</p>

        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class="p-col-fixed txt-right txt-required css-dialog-purchase">Order amount</label>
            <div class="p-inputgroup" style="width: 100%;">
              <InputNumber v-model="obj_data.price_sale"  id="price_sale"  @input="updatePoints" placeholder="0" :minFractionDigits="2" :maxFractionDigits="2"
                class="css-dialog-purchase-input width-dialog-purchar"/>
              <span class="p-inputgroup-addon css-dialog-purchase-input-don-vi">$</span>
            </div>
          </div>
        </div>
        <div class="p-card-field ">
          <div class="box_lat_log">
            <label class="p-col-fixed txt-right css-dialog-purchase">Points reward</label>
            <div class="p-inputgroup" style="width: 100%;">
              <input :value="formatNumber(obj_data.point_user)" type="text" id="point_user"
                class="form-input full-width-input css-dialog-purchase-input" placeholder="0" disabled />
              <span class="p-inputgroup-addon css-dialog-purchase-input-don-vi">point</span>
            </div>
          </div>
        </div>

        <template #footer>
          <Button label="Cancel" @click="showDeleteDialogComplete = false" icon="pi pi-times"
            class="p-button-secondary" />
          <Button label="Confirm" @click="ConfirmComplete()" icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog" />
        </template>
      </Dialog>


      <Dialog :header="dialogHeader" :visible.sync="showDeleteDialogReject" :contentStyle="{ overflow: 'visible' }"
        :modal="true">
        <p>Hera has rejected the purchase of this car due to some issues. Do you want to continue?</p>

        <div class="p-card-field ">
          <label class="p-col-fixed txt-right txt-required chu-in-dam-purchase margin-reason-aa">Reason</label>
          <div class="p-inputgroup">
            <Textarea v-model="Reason" id="reason" placeholder="Write something here..." :rows="10"></Textarea>
          </div>
        </div>

        <template #footer>
          <Button label="Cancel" @click="showDeleteDialogReject = false" icon="pi pi-times"
            class="p-button-secondary" />
          <Button label="Confirm" @click="ConfirmReject()" icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog" />
        </template>
      </Dialog>


    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices'
import moment from "moment-timezone";
import Calendar1 from '@/components/Calendar.vue';

export default {
  components: {
    Calendar1,
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      key_type_id: 1,
      deleteId: null,
      showDeleteDialog: false,
      showDeleteDialogComplete: false,
      showDeleteDialogReject: false,
      listDataType: [],
      obj_data: {
        discount: '%',
        address: '',
        phone : null,
        price_sale: 0,
        point_user: 0,
        discount_value: null,
        rental_order: {
          booking_status: null,
        },
      },
      comFilename: 1,
      listPropertyType: [],
      listPropertyTypeAll: [],
      CarElectric: '',
      listUser: [],
      listUserAll: [],
      componentKey: 0,
      list_file: [],
      list_file_cover: [],
      list_id_file_delete: [],
      list_id_file_delete_cover: [],
      maxFileSize: 2097152 * 50,
      listStatus: [
        {
          id: 1,
          name: "Request",
        },
        {
          id: 2,
          name: "Reject",
        },
        {
          id: 3,
          name: "Complete",
        },
        {
          id: 4,
          name: "Approve",
        },
        {
          id: 5,
          name: "Cancel",
        },
      ],
      listShowRoom: [],
      listVehicleCategory: [],
      listCarCommon_type1: [],
      listCarCommon_type2: [],
      listCarCommon_type3: [],
      list_type: [
        {
          id: 1,
          name: "New",
        },
        {
          id: 2,
          name: "Used",
        },
      ],
      Reason: '',
      ListSetting: [],
      SELL_A_CAR_CUMULATIVE_SPENDING: 0,
      POINTS_REWARD_SELL: 0,
      listUserComplete : [],

    }
  },
  watch: {
    'obj_data.apointment': function (newVal) {
      if (newVal) {
        this.obj_data.sell_drop_off_date = new Date(newVal);
      }
    }
  },
  async mounted() {
    this.getLisShowroom();
    this.getListSetting();
    this.getListUserActive();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      console.log('obj_dataobj_dataobj_dataobj_data', this.obj_data);

      console.log('this.obj_data.rental_order', this.obj_data.rental_order);
      this.obj_data.sell_rego_validation = this.formatDate(this.obj_data.sell_rego_validation);

      // this.obj_data.sell_showroom_id = this.obj_data.rental_order.showroom_id;
      this.obj_data.rental_order.booking_status_root = this.obj_data.rental_order.booking_status;
      if (this.obj_data.rental_order.booking_status === 'REQUEST_SELL') {
        this.obj_data.rental_order.booking_status = 'Request';
      } else if (this.obj_data.rental_order.booking_status === 'REJECT_SELL') {
        this.obj_data.rental_order.booking_status = 'Reject';
      } else if (this.obj_data.rental_order.booking_status === 'COMPLETE_SELL') {
        this.obj_data.rental_order.booking_status = 'Complete';
      } else if (this.obj_data.rental_order.booking_status === 'CANCEL_SELL') {
        this.obj_data.rental_order.booking_status = 'Cancel';
      } else if (this.obj_data.rental_order.booking_status === 'APPROVE_SELL') {
        this.obj_data.rental_order.booking_status = 'Approve';
      }
      this.obj_data.color_id = this.obj_data?.obj_colour?.name ?? null;
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit)) {
        var list_file_edit = this.model?.list_file_edit
        for (let i = 0; i < list_file_edit.length; i++) {
          var item_file = list_file_edit[i]
          var obj = { id: item_file.id, 'name': '', 'file': '', 'objectURL': item_file.url, type: 'old_edit' }//type:'old_edit' nếu gặp type này ko update avatar
          this.list_file.push(obj)
        }
      }
      if (this.obj_data.sell_drop_off_date) {
        const dateParts = this.obj_data.sell_drop_off_date.split('-');
        const year = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10) - 1; // Tháng trong JavaScript bắt đầu từ 0
        const day = parseInt(dateParts[2], 10);
        const dateObject = new Date(year, month, day);

        this.obj_data = {
          ...this.obj_data,
          apointment: dateObject
        };
      } else {
        this.obj_data = {
          ...this.obj_data,
          apointment: null
        };
      }

      this.componentKey++;
    } else {

      this.obj_data = {
        active: true,
        new: true,
        type_of_price: '1',
        ordinal: 1,
        discount: '%',
      };
      this.componentKey++;
    }
  },

  computed: {
   
    dialogHeader() {
      return `Change status #${this.obj_data.rental_order.code}`;
    },
    formattedPrice: {
      get() {
        return this.formatNumber(this.obj_data.price_sale);
      },
      set(value) {
        const amount = parseFloat(value.replace(/,/g, ''));
        if (isNaN(amount)) {
          this.obj_data.price_sale = 0;
        } else {
          this.obj_data.price_sale = amount;
          this.updatePoints();
        }
      },
    },
    formattedPoints() {
      return this.formatNumber(this.obj_data.point_user);
    },
    formattedPriceSale: {
      get() {
        // Format giá trị price_sale thành chuỗi có dấu phẩy
        return this.formatNumber(this.obj_data.price_sale);
      },
      set(value) {
        // Chuyển giá trị về số nguyên khi người dùng nhập
        this.obj_data.price_sale = parseInt(value.replace(/,/g, ''), 10);
      }
    },
    formattedPointWallet: {
      get() {
        // Format giá trị point_wallet thành chuỗi có dấu phẩy
        return this.formatNumber(this.obj_data.rental_order.point_reward);
      },
      set(value) {
        // Chuyển giá trị về số nguyên khi người dùng nhập
        this.obj_data.rental_order.point_reward = parseInt(value.replace(/,/g, ''), 10);
      }
    }
  },
  methods: {
    formatPhoneNumber(event) {
      const input = event.target.value;
      const formattedInput = input.replace(/[^0-9]/g, '');
      this.obj_data.phone = formattedInput;
    },
    formatDate(dateString) {
      console.log('Input dateString:', dateString);

      // Kiểm tra nếu định dạng là MM/YYYY
      if (/^\d{2}\/\d{4}$/.test(dateString)) {
        const [month, year] = dateString.split("/");
        const formattedMonth = String(month).padStart(2, '0');
        return `${formattedMonth}/${year}`;
      }

      // Kiểm tra nếu định dạng là YYYY-MM-DD
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month] = dateString.split("-");
        const formattedMonth = String(month).padStart(2, '0');
        return `${formattedMonth}/${year}`;
      }

      // Thử parse bằng Date nếu định dạng không xác định
      const date = new Date(dateString);
      if (!isNaN(date)) { // Kiểm tra date hợp lệ
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${year}`;
      }

      // Trả về thông báo lỗi nếu không nhận diện được định dạng
      return "Invalid date";
    },

    async deleteData() {
      this.showDeleteDialogComplete = false;
      var list_data = []
      for (let i = 0; i < this.listDataType.length; i++) {
        var item_data = this.listDataType[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataType = list_data;
    },



    handleStatusChange(newStatus) {
      console.log("Status changed to:", newStatus);
      if (newStatus === 3) {
        this.showDeleteDialogComplete = true;
        console.log("Dialog visibility set to true for Complete status");
      } else if (newStatus === 2) {
        this.showDeleteDialogReject = true;
        console.log("Dialog visibility set to true for Reject status");
      }
      else {
        this.this.showDeleteDialogReject = false;
        this.showDeleteDialogComplete = false; // Đảm bảo tắt dialog khi chọn trạng thái khác
        console.log("Dialog hidden for status:", newStatus);
      }
    },
    updatePoints() {
      // check validate gias tri price_sale khác số âm
      
      const amount = this.obj_data.price_sale;

      if (isNaN(amount) || amount <= 0) {
        this.obj_data.point_user = 0;
        return;
      }
      const threshold = this.SELL_A_CAR_CUMULATIVE_SPENDING;
      const pointsPerThreshold = this.POINTS_REWARD_SELL;
      const points = Math.floor(amount / threshold) * pointsPerThreshold;
      this.obj_data.point_user = points;
      this.validateOrderAmount();
    },
    validateOrderAmount(event) {
      // Lấy giá trị nhập vào
      let value = event.target.value;

      // Loại bỏ ký tự không phải số và dấu thập phân
      value = value.replace(/[^0-9.]/g, "");

      // Chặn số âm (loại bỏ dấu - nếu có)
      value = value.replace(/^-/g, "");

      // Giới hạn chỉ một dấu chấm thập phân
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1]; // Chỉ giữ lại phần nguyên và phần thập phân đầu tiên
      }

      // Giới hạn tối đa 3 chữ số sau dấu chấm
      if (parts[1] && parts[1].length > 3) {
        value = parts[0] + "." + parts[1].slice(0, 3); // Cắt phần thập phân còn lại chỉ để 3 chữ số
      }

      // Cập nhật lại giá trị vào obj_data.price_sale
      this.obj_data.price_sale = value;
    },
    formatNumber(value) {
      if (!value) return null;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },


    async getListUserActive() {
      var where_key = {
        deleted: {
          _eq: false,
        },
        id : { _eq: this.obj_data?.rental_order?.uid }
      }
      var list = await this.$CoreService.getListUserActive(where_key);
      this.listUserComplete = list.list;
      console.log('ddddddddddddddddddddddddddddddd', this.listUserComplete);
      
    },
    async validateInputToTal(){
      console.log('this.obj_data.price_sale', this.obj_data.price_sale);
      
      // Please enter the Order amount
      const price_sale = document.getElementById("price_sale");
      if (this.$commonFuction.isEmptyObject(this.obj_data.price_sale)) {
        price_sale.setCustomValidity("Please enter the Order amount");
      } else {
        price_sale.setCustomValidity("");
      }
      const form = document.getElementById("price_sale");
      if (!form.checkValidity()) {
        form.reportValidity();
        return true;
      }
    },
    // reason
    async validateInputReject(){
      // Please enter the Order amount
      const reason = document.getElementById("reason");
      if (this.$commonFuction.isEmptyObject(this.Reason)) {
        reason.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        reason.setCustomValidity("");
      }
      const form = document.getElementById("reason");
      if (!form.checkValidity()) {
        form.reportValidity();
        return true;
      }
    },
    async ConfirmComplete() {
      if (await this.validateInputToTal()) {
        return
      }
      try {
        this.showDeleteDialogComplete = false;
        
        // Validate required data
        if (!this.obj_data?.rental_order?.uid) {
          throw new Error('Rental order UID is missing.');
        }
        
        // Convert point_user and price_sale to integers 
        const pointUser = parseInt(this.obj_data?.point_user?.toString().replace(/,/g, ''), 10);
        const priceSale = parseInt(this.obj_data.price_sale?.toString().replace(/,/g, ''), 10);

        const userId = this.obj_data.rental_order.uid;
        const user = this.listUserComplete.find(user => user.id === userId);
        if (user) {
          user.point_wallet += parseInt(this.obj_data.point_user.toString().replace(/,/g, ''), 10);
        }
        // if (this.obj_data.rental_order.uid != null) {
        //   await this.$apollo.mutate({
        //     mutation: DataServices.updateData('users'),
        //     variables: {
        //       'data_update': { point_wallet:  user.point_wallet },
        //       'where_key': { 'id': { '_eq': this.obj_data.rental_order.uid } }
        //     }
        //   });
        // }

        // Update rental_order_sell data
        const rentalOrderSell = await this.$apollo.mutate({
          mutation: DataServices.updateData('rental_order_sell'),
          variables: {
            'data_update': { price_sale: priceSale },
            'where_key': { 'id': { '_eq': this.obj_data.id } }
          }
        });

        const returningRentalOrderSell = rentalOrderSell.data[Object.keys(rentalOrderSell.data)].returning[0];

        // Update rental_order data
        await this.$apollo.mutate({
          mutation: DataServices.updateData('rental_order'),
          variables: {
            'data_update': {
              booking_status: 'COMPLETE_SELL',
              updated_at: moment.tz(new Date(), this.time_zone_local),
              updated_by: this.$store.getters.user,
              point_reward: pointUser
            },
            'where_key': { 'id': { '_eq': returningRentalOrderSell.rental_order_id } }
          }
        });



        var BUY_A_CAR_CUMULATIVE_SPENDING = await this.$CoreService.getSetting("SELL_A_CAR_CUMULATIVE_SPENDING");
        var BUY_A_CAR_CUMULATIVE_SPENDING_VALUE = !this.$commonFuction.isEmpty(BUY_A_CAR_CUMULATIVE_SPENDING.value) ? parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING.value) : 0;
        var proportion_reward = parseInt(parseFloat(this.obj_data.price_sale) / parseFloat(BUY_A_CAR_CUMULATIVE_SPENDING_VALUE));
        var POINTS_REWARD_BUY = await this.$CoreService.getSetting("POINTS_REWARD_SELL");
        var POINTS_REWARD_BUY_VALUE = !this.$commonFuction.isEmpty(POINTS_REWARD_BUY.value) ? parseFloat(POINTS_REWARD_BUY.value) : 0;
        var point_value = proportion_reward * POINTS_REWARD_BUY_VALUE;
        var params_change_point = {
          uid: userId,
          description: `Reward - Completed sale a car #${this.obj_data?.rental_order?.code} `,
          amount: parseFloat(point_value),
          updated_by: this.obj_data?.rental_order?.uid,
          created_by: this.obj_data?.rental_order?.uid,
          type: '4',
          object_id: this.obj_data?.rental_order?.id,
          status: 'ST002'
        }
        await this.$CoreService.changePoint(params_change_point);


        var list_user = [this.obj_data?.rental_order?.uid];
        var params_noti =null;
        params_noti = {
          title: "",
          content: "",
          short_content: `[#${this.obj_data?.rental_order?.code}] Your request to sell your car has been completed. `,
          short_content_noti: `[#${this.obj_data?.rental_order?.code}] Your request to sell your car has been completed. `,
          type: null,
          action_key: this.$constants.ACTION_KEY_NOTI.DETAIL_ORDER,
          uid: null,
          multi_uid: list_user,
          object_id:  this.obj_data?.rental_order?.id,
          is_admin: false,
          key_noti: 3,//
        }
        await this.$CoreService.sendNoti(params_noti);



        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Operation completed successfully', life: 3000 });
        this.componentKey++;
        this.backToList();
      } catch (error) {
        console.error('Error:', error);
        this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
      }
    },

    async ConfirmReject() {
      if (await this.validateData()) {
        return
      }
      this.showDeleteDialogComplete = false;
      let rentalOrderSell;
      rentalOrderSell = await this.$apollo.mutate({
        mutation: DataServices.updateData('rental_order_sell'),
        variables: {
          'data_update': {
            reject_reason: this.Reason
          },
          'where_key': {
            'id': { '_eq': this.obj_data.id }
          }
        }
      })
      let returningRentalOrderSell = rentalOrderSell.data[Object.keys(rentalOrderSell.data)].returning[0];
      await this.$apollo.mutate({
        mutation: DataServices.updateData('rental_order'),
        variables: {
          'data_update': {
            booking_status: 'REJECT_SELL' ?? null,
            updated_at: moment.tz(new Date(), this.time_zone_local),
            updated_by: this.$store.getters.user,
          },
          'where_key': {
            'id': { '_eq': returningRentalOrderSell.rental_order_id }
          }
        }
      }).then(async (res) => {
        console.log("res", res);
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Reject successfully', life: 3000 })
        this.componentKey++;
      });
      this.backToList();
    },

    async onFileSelectFile(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;

      if (this.list_file.length + files.length > 20) {
        alert("You can only upload a maximum of 20 images.");
        event.target.value = null;
        return;
      }

      if (files.length > 0) {
        let acceptTags = ['jpeg', 'jpg',  'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];

        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();

          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, png, svg");
            event.target.value = null;
            return;
          }


          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }

        var arrTemp = [];
        for (let file of files) {
          file.source = file;
          file.objectURL = window.URL.createObjectURL(file);
          arrTemp.push(file);
        }

        this.list_file = this.list_file.concat(arrTemp);
      }
      event.target.value = null;
    },
    async onFileSelectFileCover(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      if (this.list_file_cover.length + files.length > 10) {
        alert("You can only upload a maximum of 10 images.");
        event.target.value = null;
        return;
      }

      if (files.length > 0) {
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];
        const maxFileSize = 2 * 1024 * 1024; // 2MB in bytes

        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();
          const fileSize = files[i].size;

          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }

          if (fileSize > maxFileSize) {
            alert("Each image must be smaller than 2MB.");
            event.target.value = null;
            return;
          }

          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }

        var arrTemp = [];
        for (let file of files) {
          file.source = file;
          file.objectURL = window.URL.createObjectURL(file);
          arrTemp.push(file);
        }

        this.list_file_cover = this.list_file_cover.concat(arrTemp);
      }

      event.target.value = null;
    },

    isImage(file) {
      return /^image\//.test(file.type);
    },

    async getListSetting() {
      var where_key = {
        deleted: { _eq: false },
        key: { _in: ['SELL_A_CAR_CUMULATIVE_SPENDING', 'POINTS_REWARD_SELL'] }
      };
      var list = await this.$CoreService.getListSetting(where_key);
      this.ListSetting = list.list;
      this.ListSetting.forEach(element => {
        if (element.key === 'SELL_A_CAR_CUMULATIVE_SPENDING') {
          this.SELL_A_CAR_CUMULATIVE_SPENDING = element.value;
        }
        if (element.key === 'POINTS_REWARD_SELL') {
          this.POINTS_REWARD_SELL = element.value;
        }
      });
      console.log('this.SELL_A_CAR_CUMULATIVE_SPENDING', this.SELL_A_CAR_CUMULATIVE_SPENDING);
      console.log('this.POINTS_REWARD_SELL', this.POINTS_REWARD_SELL);

      console.log('this.ListSetting', this.ListSetting);
    },
    async getLisShowroom() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getLisShowroom(where_key);
      this.listShowRoom = list.list;
    },


    async SearchPropertyType(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisShowroom(where_key);
        this.listPropertyType = list.list;
      } else {
        this.listPropertyType = this.listPropertyTypeAll
      }
    },
    async getListUser() {
      var where_key = {
        deleted: { _eq: false },
        role: { _eq: this.$constants.ROLE_ACCOUNT.OWNER },
      }
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser = list.list;
      this.listUserAll = list.list;
    },
    async SearchUser(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
      } else {
        this.listUser = this.listUserAll
      }
    },


    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "status", value: this.obj_data.rental_order.booking_status },
        { id: "sell_showroom_id", value: this.obj_data.sell_showroom_id  ||  this.obj_data?.rental_order?.showroom_id},
        { id: "sell_drop_off_date", value: this.obj_data.sell_drop_off_date },
        { id: "sell_plate_number", value: this.obj_data.sell_plate_number },
        { id: "sell_rego_validation", value: this.obj_data.sell_rego_validation },
        { id: "price", value: this.obj_data.price },
        { id: "odometer", value: this.obj_data.odometer },
        { id: "user", value: this.obj_data.rental_order.user.fullname },
        { id: "fullname", value: this.obj_data.fullname },
        { id: "phone", value: this.obj_data.phone },
        { id: "email", value: this.obj_data.email },

      ];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else {
            inputElement.setCustomValidity("");
          }
        }
      }

    
    



      let email_add = document.getElementById("email");
      if (this.$commonFuction.isEmpty(this.obj_data.email)){
        email_add.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      }else {
        // console.log("this.IsEmail(this.email)",this.IsEmail(this.email))
        if(!await this.$commonFuction.IsEmail(this.obj_data.email)){
          email_add.setCustomValidity("Please enter the email in the correct format");
        }else{
          email_add.setCustomValidity("");
        }
      }

      let list_file = document.getElementById("list_file");
      if (this.list_file.length === 0) {
        list_file.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file.reportValidity();
        isFormInvalid = true;
      } else {
        list_file.setCustomValidity("");
      }



      if (this.obj_data.rental_order.booking_status === 'Complete' || this.obj_data.rental_order.booking_status === 3) {
        if (this.$commonFuction.isEmptyObject(this.obj_data.price_sale)) {
        this.showDeleteDialogComplete = true;
        isFormInvalid = true;
      } 
      } 
      if (this.$commonFuction.isEmpty(this.obj_data.reject_reason)) {
        if (this.obj_data.rental_order.booking_status === 'Reject' || this.obj_data.rental_order.booking_status === 2) {
          if (this.$commonFuction.isEmptyObject(this.Reason)) {
            this.showDeleteDialogReject = true;
            isFormInvalid = true;
          }
        }
      }
   

      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async checkEmail(email){
      // if(this.email !== null && this.email !== ''){
      var where = {
        email: {'_eq': email},
        deleted: {'_eq': false},
        // type: {'_eq' : 'user'}
      }
      if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
      var {data} = await this.$apollo.query({
        query: DataServices.getList('users', {"fields" : "id, email"}),
        variables: {
          where_key: where
        },
        fetchPolicy: "network-only"
      })
      // console.log(data)
      return data && data[Object.keys(data)].length > 0
      //}
    },  
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return
      }


      if (this.obj_data.rental_order.booking_status === 'Reject' || this.obj_data.rental_order.booking_status === 2) {
          await this.ConfirmReject();
        }
      const apointmentDate = moment(this.obj_data.sell_drop_off_date, "DD/MM/YYYY", true);
      const formattedDropOffDate = apointmentDate.isValid() ? apointmentDate.format("YYYY-MM-DD") : null;
      var params = {
        ...this.obj_data,
        sell_showroom_id : this.obj_data?.showroom?.id ?? null,
        sell_drop_off_date : formattedDropOffDate,
      booking_status_root: this.obj_data?.rental_order?.booking_status_root,
      };


      if (params.sell_rego_validation instanceof Date) {
        // Nếu sell_rego_validation là đối tượng Date, định dạng lại
        params.sell_rego_validation = moment(params.sell_rego_validation).format('YYYY-MM-DD');
      } else if (typeof params.sell_rego_validation === 'string') {
        // Nếu sell_rego_validation là chuỗi "MM/YYYY", thêm ngày và chuyển thành định dạng YYYY-MM-DD
        const regoDate = moment(`${params.sell_rego_validation}-01`, 'MM/YYYY-DD');
        params.sell_rego_validation = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
      }
      console.log('paramsparamsparamsparams', params);

      params.list_file = this.list_file;
      params.list_id_file_delete = this.list_id_file_delete;
      this.$emit('save', params)
    },
    onFileClear(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item);
      }
      this.list_file.splice(index, 1);
    },
  },
}
</script>
<style lang="scss">

.p-formgrid {
  padding-top: 20px;
}

.main-style-button {
  background-color: #FFDF01 !important;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}



@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}



.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}
.p-button-outlined .p-button-label {
    color: #000000 !important;
}
.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.style_title_group_car_infomation {
  padding: 10px 0 0 0 !important;
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #0c0101;
  text-transform: uppercase;
}



.full-width-input {
  width: 100%;
  /* Chiếm toàn bộ chiều rộng của khung chứa */
  padding: 0.5rem;
  /* Khoảng cách bên trong */
  font-size: 1rem;
  /* Kích thước chữ */
  box-sizing: border-box;
  /* Đảm bảo padding không làm tăng kích thước tổng thể */
  border: 1px solid #626567;
}
.chu-in-dam-purchase {
  font-size: 17px;
  color: #180c0c;
  font-weight: bold;
 
}


.css-dialog-purchase {
  font-weight: 700;
  margin-left: 0px !important;
  margin-bottom: 10px !important;
}
.css-dialog-purchase-input {
  border: 1px solid #e5dbdb;
}

.css-dialog-purchase-input-don-vi {
  width: 50px !important;
  border: none !important;
}
.margin-info-order {
margin: 0px 0px 0px 0px !important;
}
.custom-input-value-a {
  margin-right: 20px !important;
  height: 40px !important;  
} 
.custom-input-value {
  height: 40px !important;
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.margin-reason-aa {
  margin: 0px 0px 0px 0px !important;
}

// tôi muốn nếu nội dung của reason-style quá dài thì nó sẽ hiển thị scroll nhưng mặt định nó sẽ có chiều cao co giản theo kích thước của nội dung
.reason-style {
  overflow-y: auto;
  max-height: 200px;
  resize: vertical;
  height: 200px;
  border: 1px solid #e5dbdb;
  padding: 5px;
  margin: 0px 0px 0px 0px;
}


.width-dialog-purchar {
  width: 100% !important;
}

</style>
